import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Stepper from '@mui/material/Stepper';
import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { OrderInfoType } from 'adoms-common-lib';
import { CustomerURLInformationUtil } from '../../common/customerURLInformationUtil';

const useStyles = makeStyles()((theme) => ({
  root: {
    width: '100%',
  },
  button: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  }
}));


export enum Process {
  FlightSelect = 0,
  DestinationInput = 1,
  ContactInput = 2,
  Confirm = 3,
  Complete = 4,
}

function getSteps(orderInfoType?: OrderInfoType | null) {
  if (orderInfoType === OrderInfoType.MaritimeOrderInfo) {
    return ['配送区間指定', 'お荷物情報入力', '連絡先入力', '確認', '完了'];
  }
  return ['配送区間指定', 'お荷物情報入力', '確認', '完了'];
}

function resolveActiveStep(process: Process, orderInfoType?: OrderInfoType | null) {
  if (orderInfoType === OrderInfoType.MaritimeOrderInfo) {
    // Maritime: 5 steps
    switch (process) {
      case Process.FlightSelect:
        return 0;
      case Process.DestinationInput:
        return 1;
      case Process.ContactInput:
        return 2;
      case Process.Confirm:
        return 3;
      case Process.Complete:
        return 4;
      default:
        return 0;
    }
  }

  // Non-Maritime: 4 steps (ContactInput does not exist)
  switch (process) {
    case Process.FlightSelect:
      return 0;
    case Process.DestinationInput:
      return 1;
    case Process.Confirm:
      return 2;
    case Process.Complete:
      return 3;
    case Process.ContactInput:
      // Fallback: treat it as goods input
      return 1;
    default:
      return 0;
  }
}

export default function OrderStepBar(props: any) {
  const { classes } = useStyles();
  const orderInfoType = CustomerURLInformationUtil.instance.getCustomerURLInformation()?.orderInfoType ?? null;
  const steps = getSteps(orderInfoType);
  const process: Process = props.process;
  const activeStep = resolveActiveStep(process, orderInfoType);

  return (
    <div className={classes.root}>
      <Stepper activeStep={activeStep} alternativeLabel style={{ padding: 24 }}>
        {steps.map((label, index) => {
          const stepProps: { completed?: boolean } = {};
          const labelProps: { optional?: React.ReactNode } = {};
          return (
            <Step key={label} {...stepProps}>
              <StepLabel {...labelProps}>{label}</StepLabel>
            </Step>
          );
        })}
      </Stepper>
    </div>
  );
}